import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classnames from 'classnames';
import compose from 'lodash/flowRight';
import { translate } from '@insolus/react-i18n';
import RawLink from "@insolus/ui-kit/components/Link";
import withThemeConfig from '../_utils/withThemeConfig';
import withSidebarState from '../_utils/withSidebarState';
import Nav from './Nav';
import { NavsObjectPropType } from './_types';

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  var _super = _createSuper(Header);

  function Header() {
    var _this;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      navOpen: false
    };

    _this.handleToggleSidebar = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          isSidebarOpened = _this$props.isSidebarOpened,
          setSidebarOpened = _this$props.setSidebarOpened;

      if (setSidebarOpened) {
        setSidebarOpened(!isSidebarOpened);
      }
    };

    _this.handleToggleNav = function () {
      _this.setState(function (prevState) {
        return {
          navOpen: !prevState.navOpen
        };
      });
    };

    return _this;
  }

  _createClass(Header, [{
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          version = _this$props2.version,
          homeUrl = _this$props2.homeUrl,
          themeConfig = _this$props2.themeConfig;
      var Link = themeConfig.baseComponents.Link;
      var brandNode = React.createElement("span", {
        className: "Header__brand"
      }, title);

      if (homeUrl) {
        brandNode = React.createElement(Link, {
          className: "Header__brand Header__brand--link",
          to: homeUrl
        }, title);
      }

      var versionNode = null;

      if (version) {
        var versionText = "v".concat(version);
        versionNode = React.createElement("span", {
          className: "Header__version"
        }, versionText);
      }

      return React.createElement("h1", {
        className: "Header__title"
      }, brandNode, versionNode);
    }
  }, {
    key: "renderNav",
    value: function renderNav() {
      var nav = this.props.nav;
      var navOpen = this.state.navOpen;

      if (!nav) {
        return null;
      }

      var _navs = Array.isArray(nav) ? {
        right: nav
      } : nav;

      var navs = ['left', 'right'].map(function (pos) {
        var items = _navs[pos];

        if (!items) {
          return null;
        }

        var _className = classnames('Header__nav', "Header__nav--".concat(pos));

        return React.createElement(Nav, {
          key: pos,
          className: _className,
          items: items
        });
      }).filter(Boolean);

      if (!navs) {
        return null;
      }

      var _className = classnames('Header__navs', {
        'Header__navs--opened': navOpen
      });

      return React.createElement("div", {
        className: _className
      }, navs);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          isSidebarOpened = _this$props3.isSidebarOpened,
          __ = _this$props3.__;
      var navOpen = this.state.navOpen;
      var nav = this.renderNav();
      return React.createElement("header", {
        className: classnames(className, 'Header')
      }, React.createElement(RawLink, {
        className: "Header__toggle Header__toggle--sidebar",
        icon: "bars",
        "aria-expanded": isSidebarOpened,
        onClick: this.handleToggleSidebar
      }, __("toggle-navigation")), React.createElement("div", {
        className: "Header__body"
      }, React.createElement("div", {
        className: "Header__main"
      }, this.renderTitle(), nav && React.createElement(RawLink, {
        className: "Header__toggle Header__toggle--nav",
        icon: "bars",
        "aria-label": __("toggle-navigation"),
        "aria-expanded": navOpen,
        onClick: this.handleToggleNav
      })), nav));
    }
  }]);

  return Header;
}(React.Component);

Header.defaultProps = {
  homeUrl: '/',
  version: undefined,
  nav: undefined,
  className: ''
};

var _translate = translate('theme-admin');

var _withConfig = function _withConfig(Component) {
  return withThemeConfig(Component);
};

var _withSidebarState = function _withSidebarState(Component) {
  return withSidebarState(Component);
};

var enhance = compose(_withSidebarState, _withConfig, _translate);
export default enhance(Header);